module.exports = __webpack_public_path__ + "img/couples-063.ad8d6ad5.jpg";